export const PROPOSALS_TEMPLATES_FETCH_REQUESTED = 'PROPOSALS_TEMPLATES_FETCH_REQUESTED'
export const DEAL_PROPOSALS_TEMPLATES_FETCH_REQUESTED = 'DEAL_PROPOSALS_TEMPLATES_FETCH_REQUESTED'
export const DEAL_GENERATE_PROPOSALS_REQUESTED = 'DEAL_GENERATE_PROPOSALS_REQUESTED'
export const DEAL_PROPOSALS_ADD_SELECTED_TEMPLATE_TO_STORE =
  'DEAL_PROPOSALS_ADD_SELECTED_TEMPLATE_TO_STORE'
export const TOGGLE_CLIENT_ACTION = 'TOGGLE_CLIENT_ACTION'
export const CHANGE_PROPOSAL_ACTION = 'CHANGE_PROPOSAL_ACTION'
export const DEAL_SAVE_PROPOSAL_DRAFT = 'DEAL_SAVE_PROPOSAL_DRAFT'
